export const getFirstLayerId = (mapgl, layersControllerItems) => {
  const layers = mapgl.getStyle().layers;

  const firstLayer = layers.find(e => {
    return !!layersControllerItems.find(n => {
      if (
        `${n.name}_sc_map` === e.id ||
        `${n.name}_sc_map_circle` === e.id ||
        `${n.name}_sc_map_line` === e.id ||
        `${n.name}_sc_map_fill` === e.id
      ) {
        return true;
      }
    });
  });

  return firstLayer ? firstLayer.id : layers[layers.length - 1].id;
};

export const getFirstSymbolId = (mapgl, type = "symbol") => {
  const layers = mapgl.getStyle().layers;

  return layers.find(e => e.type === type).id;
};

export const preparedMapData = (layer_id, data) => {
  switch (layer_id) {
    case "chsmeo_cams":
      return data.map(e => {
        if (!e.pdk_cams.length) e.status = "inactive";
        else if (e.pdk_cams.some(n => !n.status)) e.status = "error";
        else e.status = "work";
        return e;
      });
    case "chsmeo_cams_kps":
      return data.map(e => {
        if (!e.kps_cams.length) e.status = "inactive";
        else if (e.kps_cams.some(n => !n.status)) e.status = "error";
        else e.status = "work";
        return e;
      });
    default:
      return data;
  }
};

export const getSourceIdByActiveCardId = function(activeCardId) {
  return activeCardId.split("?id:")[0];
};

export const getLayerIdByActiveCardId = function(activeCardId) {
  return activeCardId.split("?id:")[1];
};
